import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GridDataResult, DataStateChangeEvent, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor, State, orderBy, process } from '@progress/kendo-data-query';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AttachmentComponent } from 'src/app/layout/producer-group/components/attachment/attachment.component';
import { ApiService, ObservalbeStateService, UtilityService } from '../../service';
declare var require: any;
import { saveAs } from 'file-saver';
import { UsersService } from '../../service/user.service';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-common-attachment',
  templateUrl: './common-attachment.component.html',
  styleUrls: ['./common-attachment.component.scss']
})
export class CommonAttachmentComponent implements OnInit {
  isDownloaded:any;
  gridData: any;
  screenData: any;
  AttachForm: FormGroup;
  selectedLang: any;
  multiple = false;
  allowUnsort = true;
  parentCode: any;
  dependCode: any;
  private ngUnSubscribe: Subject<any> = new Subject();
  mode: string;
  pgId: string;
  fileSize: any;
  fileSizeInKB: any;
  mimeType: any;
  DocGroups: any;
  SubGroups: any;
  selectedgroup = "--Select--";
  selectedsubgroup = "--Select--";
  sourcePath = this.utility.path.attachPath;
  fileName: any;

  sort: SortDescriptor[] = [
    {
      field: "pg_id",
      dir: "asc",
    },
  ];

  public state: State = {
    skip: 0,
    take: 5,
  };
  skip = 0;
  pageSize = 5;
  previousNext = true;
  pageSizes = true;
  position: any = "bottom";
  buttonCount = 5;
  type: any = "numeric";
  info = true;
  pageName:any;
  public gridView: GridDataResult;
  errmsg: string;
  statusMsg:any={};
  key: any;
  userInfo: any;

  constructor(public api: ApiService, public observable: ObservalbeStateService, private fb: FormBuilder,
    private toastr: ToastrService, private utility: UtilityService, private http: HttpClient,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogref: MatDialogRef<AttachmentComponent>, public userService: UsersService, private spinner: NgxSpinnerService) {
    this.userInfo = JSON.parse(localStorage.getItem('vprpinfo'));
    this.AttachForm = this.fb.group({
      name: new FormControl(''),
      file: new FormControl(''),
      fileSource: new FormControl(''),
      DocGroup: new FormControl('', [Validators.required]),
      SubGroup: new FormControl('', [Validators.required]),
      Remark: new FormControl(''),
      original_verified_flag: new FormControl('')
    });
  }

  ngOnInit(): void {
    this.selectedLang = JSON.parse(localStorage.getItem('selectedLang'));
    this.userService.getErrorMessage('AW01GENMSG_002').then(res => {this.statusMsg.select = res; console.log(`Insie`, this.statusMsg.select ) })
    this.getScreenData();
    this.getAttachmentDet();
    this.getMastersData("QCD_DOC_TYPE", "", "DocGroup");
  }

  ngOnDestroy() {
    this.AttachForm.reset();
  }

  // getKey(){
  //   this.api.getData().subscribe((res:any) => {
  //     if(res) {
  //       this.key = res.data.excryptKey;
  //     }
  //     console.log(`res`,res.data.excryptKey);
  //   })
  // }

  getScreenData() {
    const reqHeader = {
      "_user_code": this.userInfo.loginId,
      "_user_token": "",
      "_url": '/getScreendata',
      "_succ_msg": ""
    }
    this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers:      this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
    if (res) {
    this.api.get(`/getScreendata?screenCode=W08OBICXX@${res.myArrayList[0].map._user_token}`).subscribe((res: any) => {
      this.screenData = res;
    })
  }
});
  }

  getAttachmentDet() {
    const reqHeader = {
      "_user_code": this.userInfo.loginId,
      "_user_token": "",
      "_url": this.data?.pageName == 'NonMemberProfile' ? '/getPgNonmemberdtl' : '/getPgmemberprodtl',
      "_succ_msg": ""
    }
    this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers:      this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
      if (res) {

        if(this.data?.pageName != 'NonMemberProfile') {
          this.api.get(`/getPgmemberprodtl?pgId=${this.utility.objMembView.pg_id}&pgmemberId=${this.utility.objMembView.pgmember_id}@${res.myArrayList[0].map._user_token}`).subscribe((res:any) =>{
            this.pgId = res[0][0].pg_id;  
            this.gridData = res[8];
              this.loadProducts();
            })
        } else {
          this.api.get(`/getPgNonmemberdtl?pgId=${this.utility.objMembView.pg_id}&pgmemberId=${this.utility.objMembView.pgmember_id}@${res.myArrayList[0].map._user_token}`).subscribe((res:any) =>{
            this.pgId = res[0][0].pg_id;  
            this.gridData = res[3];
              this.loadProducts();
            })
        }

    }
  });
  }

  getMastersData(parentCode, dependCode, Name) {
    const reqHeader = {
      "_user_code": this.userInfo.loginId,
      "_user_token": "",
      "_url": '/getMasterdesc',
      "_succ_msg": ""
    }
    this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers:      this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
      if (res) {

    this.dependCode = dependCode;
    this.parentCode = parentCode;
    this.api.get(`/getMasterdesc?parentCode=${this.parentCode}&dependCode=${this.dependCode}@${res.myArrayList[0].map._user_token}`).subscribe((res: any) => {
      if (Name == "DocGroup") {
        this.DocGroups = res[0];
        console.log("DocGroups:", this.DocGroups)
      }
      else if (Name == "DocSubGroup") {
        this.SubGroups = res[0];
      }

    })
  }
});
  }



  /*Grid Paging*/
  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.gridView = {
      data: orderBy(this.gridData, this.sort),
      total: this.gridData.length,
    };
  }

  private loadProducts(): void {
    this.gridView = {
      data: this.gridData.slice(this.skip, this.skip + this.pageSize),
      total: this.gridData.length,
    };
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridView = process(this.gridData, this.state);
  }

  pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
    this.loadProducts();
  }
  /*Gri Pging End*/

  get f() {
    return this.AttachForm.controls;
  }

  onFileChange(event?: any) { }

  InsAttachment() { }

  DelAttachment(_data) {}


  DocGroupChange(e:any) {
    this.getMastersData("QCD_DOC_SUBTYPE", e.target.value, "DocSubGroup");
  }

  AttachClear() {
    this.AttachForm.reset();
  }

  download(_data:any) {
    this.spinner.show();
    const reqHeader = {
      "_user_code": this.userInfo.loginId,
      "_user_token": "",
      "_url": '/getdate',
      "_succ_msg": ""
    }
    this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers: this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
      if (res) {
  this.api.getWithOutLang(`/getdate@${res.myArrayList[0].map._user_token}`).subscribe((res:any) => {  
    this.getDatefordownload(_data, res.map._date);
  });
}
    });
}

  async downloads(_data: any) {
    const reqHeader = {
      "_user_code": this.userInfo.loginId,
      "_user_token": "",
      "_url": '/Memdownloads',
      "_succ_msg": ""
    }
    this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers:      this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
      if (res) {

      var FileType = _data.file_name.split(".", 2);
      var mime = require('mime');
      var mimeType = mime.getType(FileType[1])
      var b64toBlob = require('b64-to-blob');
      var blob: Blob;
      const data ={
        "Pgid" : this.pgId,
        "memId" : _data.pgmember_id,
        "fileName" : await this.api.encrypt(_data.file_name),
        "filePath" : await this.api.encrypt(_data.file_path)
      }

      this.api.post(`/Memdownloads?@${res.myArrayList[0].map._user_token}`, data).subscribe((res: any) => {
        if(res){
          blob=b64toBlob(res,mimeType)
          saveAs(blob, FileType[0]);
          blob = null;
        }
      })
    }
  });
  }

  getDatefordownload(_data: any, serverTime){
    const reqHeader = {
      "_user_code": this.userInfo.loginId,
      "_user_token": "",
      "_url": '/getAttachement',
      "_succ_msg": ""
    }
    this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers:      this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
      if (res) {
        console.log(_data.file_name);
    // var FileType = _data.file_name.split(".", 2);
    var last = _data.file_name.split(/[\s.]+/)
    const FileType = last[last.length - 1];
    const getFileName = last[0]
      var mime = require('mime');
      var mimeType = mime.getType(FileType)
      var b64toBlob = require('b64-to-blob');
      var blob: Blob;
      const data ={
        "_attachment_gid": this.api.encrypt(_data.pgmemberattachment_gid, serverTime),
        "_pg_id" : this.api.encrypt(this.pgId, serverTime),
        "_pgmember_id" : this.api.encrypt(_data.pgmember_id, serverTime),
        "_attachment_type": "PGMEM"
      }
      this.api.post(`/getAttachement?@${res.myArrayList[0].map._user_token}`, data).subscribe((res: any) => {
        this.spinner.hide();
        if(res){
          blob=b64toBlob(res,mimeType)
          saveAs(blob, getFileName);
          blob = null;
        }
      })
    }
  });
  }

  bussPlanAttachment(){ }

  closeModal(){
    this.dialogref.close({
      status: this.isDownloaded == true ? 'Success' : 'Error',
      haveFile: this.utility.havefileAttachement
    });
  }

  iudgetHeaders(url) {
    let headerValue = {};
    const token = localStorage.getItem(`token`);
      headerValue =  {
        'Content-Type':  'application/json',
        'Content-Security-Policy': "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
        'X-Tenant-Identifier': 'dynamic_lokos',
        'Authorization': token ? 'Bearer ' + token: '',
        'Cache-Control':  'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
        'Pragma': 'no-cache',
        'Expires': '0',
        "X-Frame-Options": "DENY",
        '_url': url,
        '_user_token': '',
        'userCode': this.userInfo.loginId,
        'roleCode': '',
        'blockCode': '',
    }
      return new HttpHeaders(headerValue);
    }
}